import { useContext } from 'react';
import { AdminAuthContext } from '../Contexts/AdminAuthContext';

const useAdminAuthContext = () => {
    const context = useContext(AdminAuthContext);
    if (!context) {
        throw new Error('useAdminAuthContext must be used within an AdminAuthProvider');
    }
    return context;
};

export default useAdminAuthContext;
